import { UnitError } from './UnitError';

export class UnknownUnitError extends UnitError {
  readonly badUnit: string;

  constructor(badUnit: string) {
    super(`Unknown unit "${badUnit}"`);
    this.badUnit = badUnit;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, UnknownUnitError);
    }
    Object.setPrototypeOf(this, UnknownUnitError.prototype);
  }
}
